// The /signup-confirmation answer to the server's 409 "Email taken": a
// pending email (demo claim) that another account took before the link was
// clicked. The server burns the token, so there is no retry — one way forward.
// Painted by the signup-confirmation page when `confirmEmail` sets
// `emailTaken`.
export const EmailConfirmationTaken = {
  flow: 'y',
  align: 'center center',
  gap: 'B',
  role: 'alert',
  Icon: {
    name: 'exclMark',
    size: 'A',
    color: 'dangerInk'
  },
  H3: {
    text: '{{ auth.emailTaken.title | polyglot }}',
    margin: '0'
  },
  P: {
    text: '{{ auth.emailTaken.body | polyglot }}',
    textAlign: 'center',
    color: 'paragraph',
    maxWidth: 'G'
  },
  // Same control as the sibling panels' sign-in button (EmailConfirmationSuccess).
  SigninButton: {
    extends: ['Button', 'ClickableItem'],
    text: '{{ auth.emailConfirmed.action | polyglot }}',
    margin: 'B 0 0',
    width: '100%',
    onClick: (_, el) => {
      el.router('/signin', el.getRoot())
    }
  }
}
